<ng-container  *ngIf="product$ | async as product">
  <div class="info-box"
       data-cy="mb-product-details-antibody">
    <ng-container *ngFor="let clss of product?.classifications">
      <ng-container *ngIf="clss.code === constants.abHeader">
        <div *ngFor="let feature of clss.features"
             class="row no-gutters paddings mb-3 mb-md-0">
          <div *ngIf="feature.featureValues"
               class="feature-name col-12 col-md-5 col-lg-4 pr-md-3"
               data-cy="mb-product-details-antibody-key">
            {{ feature.name }}:
          </div>
          <div class="feature-value col-12 col-md-7 col-lg-8"
               data-cy="mb-product-details-antibody-value">
            <ng-container *ngFor="let featureValue of feature?.featureValues; index as i">
                <ng-container *ngIf="i === feature.featureValues.length - 1; else elseBlock">
                  {{ featureValue?.value }}
                </ng-container>

                <ng-template #elseBlock>{{ featureValue?.value }}, </ng-template>

            </ng-container>
          </div>

        </div>
      </ng-container>

    </ng-container>
  </div>

</ng-container>
